export {
  BreadcrumbRegistryProvider,
  useBreadcrumbOverrides,
  useRegisterBreadcrumb,
  useRegisterBreadcrumbResolver,
  useRegisterPageBreadcrumbResolver,
  type BreadcrumbOverride,
  type BreadcrumbResolver,
} from "./BreadcrumbRegistry";
export {
  breadcrumbRoutePaths,
  type BreadcrumbRoutePath,
} from "./breadcrumb-routes";
